import { render, staticRenderFns } from "./select-field.vue?vue&type=template&id=005cf09c"
import script from "./select-field.vue?vue&type=script&lang=ts"
export * from "./select-field.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports